import type { SVGProps } from "react";

const SvgFlagEN = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 4.76 4.76"
        {...props}
    >
        <defs>
            <circle id="a" cx="9" cy="9" r="9" />
        </defs>
        <g fillRule="evenodd" transform="scale(.26458)">
            <mask id="b" fill="#fff">
                <use width="100%" height="100%" xlinkHref="#a" />
            </mask>
            <use width="100%" height="100%" fill="#1d77bf" xlinkHref="#a" />
            <g fill="#d0021b" stroke="#fff">
                <path
                    d="M10.5-.5h-3v8h-8v3h8v8h3v-8h8v-3h-8z"
                    mask="url(#b)"
                    transform="rotate(45 9 9)"
                />
                <path
                    d="M11.5-2.5h-5v9h-7v5h7v8h5v-8h7v-5h-7z"
                    mask="url(#b)"
                />
            </g>
        </g>
    </svg>
);

export default SvgFlagEN;
